import React, { ElementType } from 'react'

export const rtl =
  process.browser &&
  document.getElementsByTagName('html')[0].getAttribute('dir')

export const withDirection = <T = any, >(Component: ElementType) => (props: T) => (
  <Component {...props} />
)
